import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import Role from 'models/ImpactPlan/Role';
import { byId } from 'store/utils/sortFunctions';

import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: { byId: {}, bySystem: {} },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.ROLES_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: {
            byId: action.payload.results.reduce(
              (obj, role) => obj.set(String(role.id), new Role(role)),
              state.get('data').get('byId')
            ),
            bySystem: state
              .get('data')
              .get('bySystem')
              .set(
                String(action.payload.system),
                fromJS(action.payload.results.map(role => new Role(role)).sort(byId))
              ),
          },
        })
      );
    case types.ROLE_FETCH_SUCCEEDED:
    case types.ROLE_CREATE_SUCCEEDED:
    case types.ROLE_UPDATE_SUCCEEDED:
      return (() => {
        const systemId = String(action.payload.system);
        const systemRoles = state
          .get('data')
          .get('bySystem')
          .get(systemId, new List())
          .filter(role => role.id !== action.payload.id)
          .push(new Role(action.payload))
          .sort(byId);
        return state.merge(
          reduxHelper.applyReceiveInfo({
            updatePending: false,
            data: {
              byId: state
                .get('data')
                .get('byId')
                .set(String(action.payload.id), new Role(action.payload)),
              bySystem: state.get('data').get('bySystem').set(systemId, systemRoles),
            },
          })
        );
      })();
    case types.ROLE_FETCH:
    case types.ROLE_CREATE:
    case types.ROLE_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.ROLE_DELETE_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(action.payload.id.toString()),
            bySystem: state
              .get('data')
              .get('bySystem')
              .set(
                String(action.payload.system),
                state
                  .get('data')
                  .get('bySystem')
                  .get(String(action.payload.system), new List())
                  .filter(role => role.id !== action.payload.id)
              ),
          },
        })
      );
    case types.ROLE_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.ROLE_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.ROLE_FETCH_FAILED:
    case types.ROLES_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
